import { isIE } from '../utils/browsers';

const removeDiacritics = (string) =>
  isIE ? string : string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeString = (string) => removeDiacritics(string).toLowerCase();

export function searchString(value, query) {
  return normalizeString(value).includes(normalizeString(query));
}
